export default __webpack_public_path__ + "alberta-packaging.294388505b6862be2980.svg";